import { gql } from "@apollo/client"

export const EXPORT_HOUSEHOLD_TOUR_QUERY = gql`
  query exportHouseholdTour($tourId: Int!, $format: HouseholdExportFormat!) {
    exportHouseholdTour(tourId: $tourId, format: $format)
  }
`
